// Etapas da emissão da NF-e (fiscal.step gravado pela API) → rótulo e percentual.
const NFE_STEPS = {
  cliente: { label: "Cadastrando o cliente no Bling", percent: 20 },
  produtos: { label: "Conferindo os produtos no Bling", percent: 40 },
  pedido: { label: "Criando o pedido de venda", percent: 60 },
  nota: { label: "Gerando a NF-e", percent: 75 },
  sefaz: { label: "Transmitindo para a SEFAZ", percent: 90 },
};

export function nfeProgress(step) {
  return NFE_STEPS[step] || { label: "Iniciando a emissão", percent: 5 };
}

// Progresso de um envio em lotes: total = já feitos + restantes.
export function batchProgress(done, remaining) {
  const total = done + (remaining || 0);
  return { total, percent: total ? (done / total) * 100 : 0 };
}
